/**
 * How many places a trip visits. A loop ends where it started, so the trip
 * home doesn't count as a new place: Melbourne → Lorne → Port Fairy →
 * Melbourne is 3 places, not 4.
 */
type PlaceLike = { name: string; lat?: number | null; lng?: number | null };

/** Ends where it started (within ~5 km, or the same name). */
export function isLoop(stops: PlaceLike[]): boolean {
  if (stops.length < 3) return false;
  const a = stops[0];
  const b = stops[stops.length - 1];
  if (typeof a.lat === 'number' && typeof b.lat === 'number' && typeof a.lng === 'number' && typeof b.lng === 'number') {
    return Math.abs(a.lat - b.lat) < 0.05 && Math.abs(a.lng - b.lng) < 0.05;
  }
  const n = (s: { name: string }) => (s.name || '').split(',')[0].trim().toLowerCase();
  return !!n(a) && n(a) === n(b);
}

/** Stops, less the return home on a loop. */
export function placeCount(stops: PlaceLike[]): number {
  return stops.length - (isLoop(stops) ? 1 : 0);
}
